import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
import Vue from 'vue';
import Mixin from './mixin';
import InnerDialog from './dialog.js';
var __vue_script__ = {
  name: 'DialogWrap',
  components: {
    InnerDialog: InnerDialog
  },
  mixins: [Mixin],
  props: {
    getContainer: {
      type: Function,
      default: function _default() {
        return document.body;
      }
    }
  },
  data: function data() {
    return {
      init: false,
      portal: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    var $refs = this.$refs,
        portal = this.portal,
        getDialogVNode = this.getDialogVNode,
        $props = this.$props,
        $listeners = this.$listeners,
        $slots = this.$slots;
    var innerDialogRef = $refs.innerDialogRef;

    if (portal) {
      portal.dialogVNode = getDialogVNode(_objectSpread({}, $props, {}, {
        value: false
      }), $listeners, $slots);
    }

    if (innerDialogRef && innerDialogRef.value) {
      innerDialogRef.$once('after-close', function () {
        _this.clearPortal();
      });
    } else {
      this.clearPortal();
    }
  },
  methods: {
    getDialogVNode: function getDialogVNode(props, listeners, slots) {
      var h = this.$createElement;
      return h("inner-dialog", _mergeJSXProps([{}, {
        props: props,
        on: listeners,
        ref: 'innerDialogRef'
      }]), [h("template", {
        "slot": "title"
      }, [slots.title]), slots.default, h("template", {
        "slot": "footer"
      }, [slots.footer])]);
    },
    mountPortal: function mountPortal(vm) {
      var portal = this.portal;
      portal = vm || portal;
      var container = this.getContainer();

      if (portal) {
        container.appendChild(portal.$el);
      }
    },
    createPortal: function createPortal(dialog) {
      var vm = new Vue({
        parent: this,
        data: function data() {
          return {
            dialogVNode: null
          };
        },
        destroyed: function destroyed() {
          var parentNode = this.$el.parentNode;

          if (parentNode) {
            parentNode.removeChild(this.$el);
          }
        },
        render: function render() {
          var dialogVNode = this.dialogVNode;
          return dialogVNode;
        }
      }).$mount();
      vm.dialogVNode = dialog;
      this.mountPortal(vm);
      return vm;
    },
    clearPortal: function clearPortal() {
      var portal = this.portal;

      if (portal) {
        portal.$destroy();
      }
    }
  },
  // eslint-disable-next-line
  render: function render() {
    var $props = this.$props,
        $listeners = this.$listeners,
        $slots = this.$slots,
        value = this.value,
        init = this.init,
        portal = this.portal,
        createPortal = this.createPortal,
        getDialogVNode = this.getDialogVNode;

    if (!init && !value) {
      return;
    }

    this.init = true;
    var dialog = getDialogVNode($props, $listeners, $slots);

    if (portal) {
      portal.dialogVNode = dialog;
    } else {
      this.portal = createPortal(dialog);
    }
  }
};
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "dialogWrap.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);